module.exports = "<div class=\"timeline-wrapper\">\n  <div class=\"timeline-item\">\n    <div class=\"animated-background\">\n      <div class=\"background-masker content-first-end\"></div>\n      <div class=\"background-masker content-second-line\"></div>\n      <div class=\"background-masker content-second-end\"></div>\n      <div class=\"background-masker content-third-line\"></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/loaders/loader-desk-menu/loader-desk-menu.component.html
// module id = ../../../../../src/app/components/loaders/loader-desk-menu/loader-desk-menu.component.html
// module chunks = main